import * as React from 'react';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { green, red } from '@mui/material/colors';
import SwipeableViews from 'react-swipeable-views/lib/SwipeableViews';
import { TabPanel } from '../../../../../EvaluationE/UI/EvaluationSideTabs';
import Multiselect from '../../../../../../UI/Multiselect/Multiselect';
import WYSIWYG from '../../../../../../UI/WYSIWYG/WYSIWYG';
import { LiquidLoader } from '../../../../../../UI/lottie';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { useAlert } from 'react-alert';
import { useDispatch } from 'react-redux';
import {IAgenda } from '../../../meeting';
import { boolean } from 'yup';
// import { differenceDays } from 'components/UI/WYSIWYG/MinutesEditor';

export const AntTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    display: 'none'
  },
});
export const theme = createTheme({
  palette: {
    primary: {
      light: '#4254b9',
      main: '#3f51b5',
      dark: '#364599',
      contrastText: '#fff'
    },
  },
  typography: {
    fontFamily: [
      'quicksand',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
  }
});

// @ts-ignore
export const AntTab = styled((props: { label: string | React.ReactElement, disabled?: Boolean, color?: string, background?: string }) => <Tab {...props} />, {
  shouldForwardProp: (prop) => prop !== "color" && prop !== 'background',
})<{ background?: string; color?: string }>(({ theme, background, color }) => ({
  textTransform: 'none',
  minWidth: '25%',
  padding: '13px 19px',
  fontWeight: theme.typography.fontWeightRegular,
  color: color ?? 'rgba(0, 0, 0, 0.85)',
  alignItems: 'start',
  transition: 'all .2s',
  background: background ?? '#eee',
  '& .MuiTabs-indicator': {
    display: 'none'
  },
}));
export const Tag = styled((props: any) => <Box {...props} />, {
  shouldForwardProp: (prop) => prop !== "color" && prop !== "background",
})<{ background?: string, color?: string }>(({ background, color }) => ({
  width: '30px',
  height: '30px',
  fontSize: '22px',
  padding: 5,
  color: color ?? '#3f51b5',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: background ?? 'white',
  borderRadius: '50%',
  marginTop: 8
}))

interface InprogressStepperProps {
  parentAgendaItems: IAgenda[],
  agendaAdoptHandler: any,
  attendanceRollCallHandler: any,
  attendanceRegister: any,
  precedingMinutesUpdateHandler: any,
  precedingMinutes: any,
  agendaItems: any,
  minutesTemplate: any,
  editorChangeHandler: any,
  agendaItemsRef: React.Ref<string | null>,
  parentState: any,
  value: any,
  setValue: any,
  error: any,
  setError: any,
  adoptAgendaRef: any,
  initialValues: any,
  hasAttendees: any,
  setHasAttendees: any
  meetingId: number | string
  savedMinutes: null | string,
  implimentMeetingLock : any
}
interface Data {
  present: Array<any>,
  apologised: Array<any>,
  absent: Array<any>,
  adoptedAgenda: Array<any>,
  minutes: string,
  actionItems?: any,
  resolutions?: any
}


export default function InprogressStepper({
  parentAgendaItems,
  agendaAdoptHandler,
  attendanceRollCallHandler,
  attendanceRegister,
  precedingMinutesUpdateHandler,
  precedingMinutes,
  agendaItems,
  minutesTemplate,
  agendaItemsRef,
  parentState,
  value,
  setValue,
  error,
  setError,
  adoptAgendaRef,
  initialValues,
  hasAttendees,
  setHasAttendees,
  meetingId,
  savedMinutes,
}: InprogressStepperProps) {
  const [loading, setLoading] = React.useState<boolean>(true)
  const [isCompleting, setIsCompleting] = React.useState<boolean>(false);
  const [clicked, setClicked] = React.useState<number | null>(null);
  const timeout = React.useRef<any>(null)
  const [updated, setUpdated] = React.useState<Array<any>>([]);
  const savedOptionSelected = React.useRef<boolean>(savedMinutes ? false : true)
  const alert = useAlert();
  const dispatch = useDispatch();

  // React.useEffect(() => {
  //   let fetchedActionItems: any[] = []
  //   if (Array.isArray(adoptAgendaRef.current) && adoptAgendaRef.current) {
  //     adoptAgendaRef.current.forEach((adoptedAgenda: any) => {
  //       if (adoptedAgenda.id) {
  //         axios.get(`/meeting/action_items/${adoptedAgenda.id}`)
  //           .then(res => {
  //             if (Array.isArray(res.data)) {
  //               setLoading(false)
  //               res.data.forEach((action: any) => {
  //                 const diff = differenceDays(new Date(action.due), new Date(action.reminder_date))
  //                 let reminderT_Minus;
  //                 if (diff < 6) reminderT_Minus = "- 1 day";
  //                 else if (diff < 28) reminderT_Minus = "- 1 week"
  //                 else if (diff >= 28) reminderT_Minus = "- 1 month"
  //                 else reminderT_Minus = "- 1 day";

  //                 const reminderChannels = []

  //                 if (action.sms !== undefined && action.sms?.toUpperCase() === 'YES') {
  //                   reminderChannels.push('sms')
  //                 }
  //                 if (action.mail !== undefined && action.mail?.toUpperCase() === 'YES') {
  //                   reminderChannels.push('mail')
  //                 }

  //                 const actionObj = {
  //                   agenda: adoptedAgenda.id,
  //                   action: action.task,
  //                   assignee: `${action.id_user}:${action.assignee}:${action.is_external ? 'external' : 'internal'}`,
  //                   due: new Date(action.due),
  //                   reminderChannels: reminderChannels,
  //                   remindT_Minus: reminderT_Minus
  //                 }
  //                 fetchedActionItems = [...fetchedActionItems, actionObj]
  //                 fetchedActionItems.length > 0 && sessionStorage.setItem("actionItems", JSON.stringify(fetchedActionItems))
  //               })

  //             } else {
  //               setLoading(false)
  //             }
  //           })
  //           .catch(e => setError(2))
  //       }
  //     })

  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [updated, meetingId, adoptAgendaRef, value])

  const minutesHandler = async () => {
    if (isCompleting) {
      return null;
    }

    if (!parentState.attendance) {
      alert.show('An error has occured while completing meeting', { type: 'error' })
      return null;
    }
    try {
      setIsCompleting(true);
      const actionItems = sessionStorage.getItem("actionItems") ? JSON.parse(sessionStorage.getItem("actionItems") ?? '') : null;
      const resolutions = sessionStorage.getItem("resolutions") ? JSON.parse(sessionStorage.getItem("resolutions") ?? '') : null;
      const data: Data = {
        present: Array.isArray(parentState.attendance.present) ? parentState.attendance.present : [],
        apologised: Array.isArray(parentState.attendance.apologised) ? parentState.attendance.apologised : [],
        absent: Array.isArray(parentState.attendance.absent) ? parentState.attendance.absent : [],
        adoptedAgenda: Array.isArray(parentState.adoptedAgenda) ? parentState.adoptedAgenda : [],
        resolutions: resolutions,
        actionItems: actionItems,
        // @ts-expect-error
        minutes: String(agendaItemsRef.current ?? '')
      };

      const response = await axios.post(
        `meetings/${meetingId}/minutes`, data, { timeout: 45000 }
      );

      if (response) {
        if (response.data.code !== 200) {
          return alert.show(response.data.message || "Could not complete meeting", { type: "error" });
        }
        alert.show("Minutes saved", { type: "success" });
        return dispatch({ type: "COMPLETE_MEETING", payload: { id: meetingId } });
      }
    } catch (error: any) {
      if (error?.code === "ECONNABORTED") {
        alert.show("Request timed out while completing meeting. Please try again.", { type: "error" });
        return null;
      }
      alert.show(error?.response?.data?.message || error?.message || "An error has occured while completing meeting", { type: "error" });
      return null;
    } finally {
      setIsCompleting(false);
    }
  };

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    if (!navigator.onLine) return alert.show('You are offline, Connect to a stable internet connection to continue', { type: "error" });
    if (newValue === 4) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Paper sx={{
              minHeight: 'max-content',
              maxWidth: 'max-content',
              borderRadius: 1,
              padding: 2,
              boxShadow: '0px 0px 30px -7px rgb(0 0 0 /20%)'
            }} >
              <Stack direction="column" spacing={2}>
                <Typography variant='h5'>Complete This Meeting? This action cannot be undone</Typography>
                <Stack direction="row" spacing={5} justifyContent='space-between'>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      onClose();
                    }}

                  >CANCEL</Button>
                  <Button
                    variant="contained"
                    color="success"
                    disabled={isCompleting}
                    onClick={() => {
                      minutesHandler()
                      // props.implimentMeetingLock()
                      onClose();
                    }}
                  >{isCompleting ? "COMPLETING..." : "COMPLETE"}</Button>
                </Stack>
              </Stack>
            </Paper>
          );
        },
        closeOnEscape: false,
        closeOnClickOutside: false,
        overlayClassName: 'react-confirm-alert-custom-overlay'
      })
      return;
    }
    if (newValue === 3 && savedMinutes && !savedOptionSelected.current) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Paper sx={{
              minHeight: 'max-content',
              maxWidth: 'max-content',
              borderRadius: 2,
              padding: 2,
              boxShadow: '0px 0px 30px -7px rgb(0 0 0 /20%)'
            }} >
              <Stack direction="column" spacing={2}>
                <Typography variant='h5'>Continue where you left off?</Typography>
                <Stack direction="row" spacing={5}>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      savedOptionSelected.current = true
                      onClose()
                      // setLoading(true)
                      setValue(newValue)
                    }}

                  >DISCARD SAVED MINUTES</Button>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => {
                      savedOptionSelected.current = true
                      // @ts-expect-error
                      agendaItemsRef.current = savedMinutes
                      onClose()
                      // setLoading(true)
                      setValue(newValue)
                    }}

                  >CONTINUE</Button>

                </Stack>
              </Stack>
            </Paper>
          );
        },
        closeOnEscape: false,
        closeOnClickOutside: false,
        overlayClassName: 'react-confirm-alert-custom-overlay'
      })
      return;
    }
    if (newValue > 3) return;
    if (newValue > value) {
      if (!parentState.attendance.present) return setError(0);
      if (!parentState.adoptedAgenda && newValue === 1) return setError(1);
      if ((error ? value <= error : true)) {
        switch (value) {
          case 0:
            if (!updated.includes(0)) return setValue(newValue);
            setClicked(newValue)
            setLoading(true)
            const parentCopy = { ...parentState }
            parentCopy.attendance.present = parentCopy.attendance.present.map((x: any) => {
              let id: null | number = null
              let name: null | string = null

              if (typeof x === 'string') {
                let attendee = x.split(':')
                id = parseInt(attendee[0])
                name = attendee[1]?.toLowerCase();
              } else if (x) {
                id = x.id
                name = x.name
              }
              if (!id || !name) return x;
              let is_external = false;
              if (parentCopy.invitees.some((y: any) => {
                return y.is_external && y.id === id
              })) {
                is_external = true;
              }
              return { id: id, name: name, is_external: is_external }
            })
            parentCopy.attendance.apologised = parentCopy.attendance.apologised.map((x: any) => {
              let id: null | number = null
              let name: null | string = null

              if (typeof x === 'string') {
                let attendee = x.split(':')
                id = parseInt(attendee[0])
                name = attendee[1]?.toLowerCase();
              } else if (x) {
                id = x.id
                name = x.name
              }
              if (!id || !name) return x;
              let is_external = false;
              if (parentCopy.invitees.some((y: any) => {
                return y.is_external && y.id === id
              })) {
                is_external = true;
              }
              return { id: id, name: name, is_external: is_external }
            })
            parentCopy.attendance.absent = parentCopy.attendance.absent.map((x: any) => {
              let id: null | number = null
              let name: null | string = null

              if (typeof x === 'string') {
                let attendee = x.split(':')
                id = parseInt(attendee[0])
                name = attendee[1]?.toLowerCase();
              } else if (x) {
                id = x.id
                name = x.name
              }
              if (!id || !name) return x;
              let is_external = false;
              if (parentCopy.invitees.some((y: any) => {
                return y.is_external && y.id === id
              })) {
                is_external = true;
              }
              return { id: id, name: name, is_external: is_external }
            })
            parentState.meeting && parentState.meeting.id && (
              !hasAttendees ?
                axios.post(`/meeting/${parentState.meeting.id}/attendance`, {
                  present: parentState.attendance.present,
                  absent: parentState.attendance.absent,
                  apologised: parentState.attendance.apologised
                })
                  .then(res => {
                    if (res.data) {
                      setHasAttendees(true)
                      setLoading(false)
                    } else {
                      setLoading(false)
                      setValue(0)
                      alert.show('Failed to update attendance', { type: 'error' })
                    }
                  })
                  .catch(() => {
                    alert.show('Failed to update attendance', { type: 'error' })
                    setLoading(false);
                  })
                :
                axios.patch(`/meeting/${parentCopy.meeting.id}/attendance`, {
                  present: parentCopy.attendance.present,
                  absent: parentCopy.attendance.absent,
                  apologised: parentCopy.attendance.apologised
                })
                  .then(res => {
                    if (res.data) {
                      setHasAttendees(true)
                      setLoading(false)
                      setUpdated(updated.filter(x => x !== 0))
                    } else {
                      setLoading(false)
                      setValue(0)
                      alert.show('Failed to update attendance', { type: 'error' })
                    }
                  })
                  .catch(() => {
                    alert.show('Failed to update attendance', { type: 'error' })
                    setValue(0)
                    setLoading(false);
                  }))
            break;
          case 1:
            if (!updated.includes(1)) return setValue(newValue);
            setClicked(newValue)
            setLoading(true)
            axios.post(`/meetings/${parentState.meeting.id}}/minutes/update_agenda`, { adoptedAgenda: parentState.adoptedAgenda })
              .then(res => {
                setValue(1);
                setLoading(false);
                setUpdated(updated.filter(x => x !== 1))
                adoptAgendaRef.current = parentState.adoptedAgenda
              })
              .catch(() => setLoading(false))
            break;
          default:
            setClicked(newValue)
            setValue(newValue)
            setLoading(false)
            break;
        }
      }
    } else setValue(newValue)
  };

  const color = React.useCallback(
    (current: number): { color: string, bgcolor: string, textColor: string, opacity: number, tab?: string } => {
      if (loading) {
        return {
          color: '#fff',
          bgcolor: '#000',
          textColor: '#000',
          tab: loading && clicked === current ? 'lightgrey' : '#eee',
          opacity: loading && clicked === current ? .5 : .2
        }
      }
      if (error === current) {
        return {
          color: red[500],
          bgcolor: '#fff',
          textColor: '#fff',
          opacity: 1,
          tab: red[500]
        }
      }

      if (value === current) {
        return {
          color: theme.palette.primary.main,
          bgcolor: '#fff',
          textColor: '#fff',
          opacity: 1,
          tab: theme.palette.primary.main
        }
      }
      else if (value > current) {
        return {
          color: green[500],
          bgcolor: '#fff',
          textColor: '#fff',
          opacity: 1,
          tab: green[500]
        }
      }
      else return {
        color: '#fff',
        bgcolor: '#000',
        textColor: '#000',
        tab: loading && clicked === current ? 'lightgrey' : '#eee',
        opacity: loading && clicked === current ? .5 : .2
      }
    }, [value, error, clicked, loading])

  React.useEffect(() => {
    if (!parentState.attendance.present) setError(null);
    if (!(Array.isArray(parentState.attendance.present) ? parentState.attendance.present.length < 1 : false)) return setError(null);
    else setError(0)

  }, [parentState.attendance.present, setError])

  React.useEffect(() => {
    initialValues && setLoading(false)
  }, [initialValues])


  React.useEffect(() => {
    const innerTimeout = timeout.current
    !loading && clicked && setValue(clicked);

    return () => {
      // @ts-ignore
      innerTimeout && clearTimeout(innerTimeout)
    }
  }, [clicked, loading, setValue])

  React.useEffect(() => {
    if (!parentState.adoptedAgenda) return;
    if (!(Array.isArray(parentState.adoptedAgenda) ? parentState.adoptedAgenda.length < 1 : false)) return setError(null);
    else setError(1)
  }, [parentState.adoptedAgenda, setError])



  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: '100%', bgcolor: '#fff', pt: 5, pb: 2, px: 2, borderTop: '3px solid rgb(0, 0, 0, .6)', borderRadius: 1 }}>
        <AntTabs value={value} onChange={handleChange} aria-label="inprogress-stepper" sx={{ minWidth: '100%' }}>
          <AntTab
            label={
              <Stack direction='row' sx={{ opacity: color(0).opacity }}>
                <Tag color={color(0).color} background={color(0).bgcolor}>1</Tag>
                <Stack sx={{ textAlign: 'left', pl: 1.2 }} >
                  <span style={{ color: color(0).textColor, margin: 0, fontSize: '1.3rem', lineHeight: 1.5 }}>Attendance</span>
                  <p style={{ color: color(0).textColor, margin: 0 }}>{loading && clicked === 0 ? 'Loading...' : 'Mark attendance register'}</p>
                </Stack>
              </Stack>}
            {...(color(0).tab ? { background: color(0).tab, color: '#fff' } : {})}
            disabled={loading}
          />
          <AntTab
            label={
              <Stack direction='row' sx={{ opacity: color(1).opacity }}>
                <Tag color={color(1).color} background={color(1).bgcolor}>2</Tag>
                <Stack sx={{ textAlign: 'left', pl: 1.2 }}>
                  <span style={{ color: color(1).textColor, margin: 0, fontSize: '1.3rem', lineHeight: 1.5 }}>Adopt agenda</span>
                  <p style={{ color: color(1).textColor, margin: 0 }}>{loading && clicked === 1 ? 'Loading...' : 'Adopt meeting agenda'}</p>
                </Stack>
              </Stack>}
            {...(color(1).tab ? { background: color(1).tab, color: '#fff' } : {})}
            disabled={error === value || loading}
          />
          <AntTab
            label={
              <Stack direction='row' sx={{ opacity: color(2).opacity }}>
                <Tag color={color(2).color} background={color(2).bgcolor}>3</Tag>
                <Stack sx={{ textAlign: 'left', pl: 1.2 }}>
                  <span style={{ color: color(2).textColor, margin: 0, fontSize: '1.3rem', lineHeight: 1.5 }}>Previous minutes</span>
                  <p style={{ color: color(2).textColor, margin: 0 }}>{loading && clicked === 2 ? 'Loading...' : 'Confirm previous minutes'}</p>
                </Stack>
              </Stack>}
            {...(color(2).tab ? { background: color(2).tab, color: '#fff' } : {})}
            disabled={error === value || loading}
          />
          <AntTab
            label={
              <Stack direction='row' sx={{ opacity: color(3).opacity }}>
                <Tag color={color(3).color} background={color(3).bgcolor}>4</Tag>
                <Stack sx={{ textAlign: 'left', pl: 1.2 }}>
                  <span style={{ color: color(3).textColor, margin: 0, fontSize: '1.3rem', lineHeight: 1.5 }}>Minutes</span>
                  <p style={{ color: color(3).textColor, margin: 0 }}>{loading && clicked === 3 ? 'Loading...' : 'Take minutes'}</p>
                </Stack>
              </Stack>}
            {...(color(3).tab ? { background: color(3).tab, color: '#fff' } : {})}
            disabled={error === value || loading}
          />
        </AntTabs>

        <SwipeableViews
          axis={"x"}
          index={value}
          style={{ height: '100%', width: '100%', overflowY: 'hidden' }}

        >
          <TabPanel value={value} index={0} >
            <Box pt={2} height='50vh'>
              {
                loading ?
                  <Box sx={{
                    minHeight: '80%',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minWidth: "100%"
                  }}>
                    <Stack>
                      <LiquidLoader
                        height={180}
                        width={180}
                        loop={true}
                      />

                      <Typography sx={{ opacity: .9, textAlign: 'center' }}>Loading...</Typography>
                    </Stack>
                  </Box>

                  :
                  <>
                    {
                      error === 0 &&
                      <div className="alert alert-danger alert-dismissible">
                        <i
                          className="icon fa-info-circle"
                          aria-hidden="true"
                        ></i>&nbsp;
                        Atleast one member should be present to continue
                      </div>
                    }
                    {
                      <>
                        <Multiselect
                          module="MEETING_ATTENDANCE_REGISTER"
                          data={attendanceRegister}
                          selected={[...(initialValues ?? [])]}
                          withGrouping
                          selectHandler={(invitees: Array<any>, attendees: Array<any>) => {
                            if (Array.isArray(parentState.attendance.present) && Array.isArray(attendees)) {
                              if (parentState.attendance.present.some((x: any) => x.id)) {
                                const intitial = attendees.filter((x: any) => x.group === 'Present').map((y: any) => parseInt(y.id.split(":")[2]))
                                const current = parentState.attendance.present.map((x: any) => x.id)
                                if (current.some((z: any) => intitial.includes(z))) setUpdated([...updated, 0])

                              }
                              else {
                                const intitial = attendees.filter((x: any) => x.group === 'Present').map((y: any) => parseInt(y.id.split(":")[2]))
                                const current = parentState.attendance.present.map((x: any) => parseInt(x.split(":")[0]))
                                if (current.some((z: any) => intitial.includes(z)) && !updated.includes(0)) setUpdated([...updated, 0])
                              }
                            }
                            return attendanceRollCallHandler(invitees, attendees)
                          }}
                          height={error === 0 ? '85%' : '100%'}
                          showSelectAll={false}
                        />
                      </>
                    }
                  </>
              }
            </Box>
            {/* <React.Suspense fallback={<ModuleIsMounting module="Evaluations" />}><Content tab={"Evaluation"} /></React.Suspense> */}
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box pt={2} height='50vh'>
              {
                loading ?
                  <Box sx={{
                    minHeight: '80%',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minWidth: "100%"
                  }}>
                    <Stack>
                      <LiquidLoader
                        height={180}
                        width={180}
                        loop={true}
                      />
                      <Typography sx={{ opacity: .9, textAlign: 'center' }}>Loading...</Typography>
                    </Stack>
                  </Box>

                  :
                  <>
                    {
                      error === 1 &&
                      <div className="alert alert-danger alert-dismissible">
                        <i
                          className="icon fa-info-circle"
                          aria-hidden="true"
                        ></i>&nbsp;
                        Select atleast one agenda to continue
                      </div>
                    }
                    <Multiselect
                      module="MEETING_AGENDA_ADOPTION"
                      data={parentAgendaItems}
                      selected={[...(adoptAgendaRef.current ?? [])]}
                      selectHandler={(agenda: Array<{ id: number, agenda: string }>) => {
                        if (Array.isArray(parentState.adoptedAgenda) && Array.isArray(agenda) && parentState.adoptedAgenda.length !== agenda.length && !updated.includes(1)) setUpdated([...updated, 1])
                        return agendaAdoptHandler(agenda)
                      }}
                      showSelectAll
                      height={error === 1 ? '85%' : '100%'}
                    />
                  </>
              }
            </Box>
            {/* <React.Suspense fallback={<ModuleIsMounting module="Categories" />}><Content tab={"Categories"} /></React.Suspense> */}
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box pt={2} height='50vh'>

              {
                loading ?
                  <Box sx={{
                    minHeight: '80%',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minWidth: "100%"
                  }}>
                    <Stack>
                      <LiquidLoader
                        height={180}
                        width={180}
                        loop={true}
                      />

                      <Typography sx={{ opacity: .9, textAlign: 'center' }}>Loading...</Typography>
                    </Stack>
                  </Box>

                  :
                  precedingMinutes ?
                    <WYSIWYG
                      module="MEETING_MINUTES_MUTATION"
                      content={precedingMinutes}
                      onSave={precedingMinutesUpdateHandler}
                      height='35vh'
                    />
                    :
                    <Box sx={{
                      minHeight: '100%',
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minWidth: "100%"
                    }}>
                      <div style={{ textAlign: "center", color: "#f44336" }}>
                        <i
                          className="icon md-alert-circle-o"
                          style={{ fontSize: "50px" }}
                          aria-hidden="true"
                        ></i>
                        <p style={{ fontSize: "18px" }}>
                          Minutes of the previous meeting do not exist
                        </p>
                      </div>
                    </Box>
              }
            </Box>
            {/* <React.Suspense fallback={<ModuleIsMounting module="Scales" />}><Content tab={"Scales"} /></React.Suspense> */}
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Box pt={2} height='50vh'>
              {
                // loading && savedOptionSelected ?
                loading ?
                  < Box sx={{
                    minHeight: '80%',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minWidth: "100%"
                  }}>
                    <Stack>
                      <LiquidLoader
                        height={180}
                        width={180}
                        loop={true}
                      />
                      <Typography sx={{ opacity: .9, textAlign: 'center' }}>Loading...</Typography>
                    </Stack>
                  </Box>

                  :
                  <WYSIWYG
                    module="MEETING_MINUTES_TAKING"
                    content={agendaItems}
                    contentRef={agendaItemsRef}
                    minutesTemplate={minutesTemplate}
                    changeHandler={() => null}
                    meetingId={meetingId}
                    adoptedAgenda={adoptAgendaRef.current}
                    height='35vh'
                  />
              }
            </Box>
            {/* <React.Suspense fallback={<ModuleIsMounting module="Scales" />}><Content tab={"Scales"} /></React.Suspense> */}
          </TabPanel>
        </SwipeableViews>
        <Stack direction='row' width='100%' sx={{ display: 'flex', justifyContent: 'space-between', pt: 4 }}>
          <Button variant='contained' sx={{
            background: value === 0 ? 'lightgrey' : 'grey',
            '&:hover': {
              background: value === 0 ? 'lightgrey' : 'grey',
            },
            '&.active': {
              background: value === 0 ? 'lightgrey' : 'grey',
            }
          }} onClick={() => value > 0 && setValue(value - 1)} disabled={value === 0 || loading} >{loading ? 'Loading...' : 'Back'}</Button>
          <Button variant='contained' sx={{
            background: value === 3 ? green[500] : '#3f51b5',
            '&:hover': {
              color: '#fff',
              background: value === 3 ? green[500] : '#3c4dab',
            },
            '&.active': {
              color: '#fff',
              background: value === 3 ? green[500] : '#3f51b5'
            }
          }}
            // TODO ...
            onClick={(e) => {
              handleChange(e, value + 1)
            }}
            disabled={error === value || loading}
          >{loading ? 'Loading...' : (value === 3 ? 'Complete' : 'Next')}</Button>
        </Stack>
      </Box>
    </ThemeProvider >
  );
}
